var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:arrow-left-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.39058 15.5001C3.39058 15.8855 3.54368 16.2551 3.81619 16.5276C4.0887 16.8001 4.45831 16.9532 4.8437 16.9532H22.6445L16.4057 23.1907C16.1327 23.4637 15.9794 23.834 15.9794 24.22C15.9794 24.6061 16.1327 24.9763 16.4057 25.2493C16.6787 25.5223 17.049 25.6757 17.435 25.6757C17.8211 25.6757 18.1913 25.5223 18.4643 25.2493L27.1831 16.5306C27.3185 16.3956 27.426 16.2352 27.4994 16.0585C27.5727 15.8819 27.6105 15.6925 27.6105 15.5013C27.6105 15.31 27.5727 15.1206 27.4994 14.944C27.426 14.7674 27.3185 14.607 27.1831 14.472L18.4643 5.75322C18.3292 5.61805 18.1687 5.51083 17.9921 5.43768C17.8155 5.36452 17.6262 5.32687 17.435 5.32687C17.2439 5.32687 17.0546 5.36452 16.878 5.43768C16.7014 5.51083 16.5409 5.61805 16.4057 5.75322C16.2706 5.88839 16.1633 6.04886 16.0902 6.22547C16.017 6.40207 15.9794 6.59136 15.9794 6.78252C15.9794 6.97368 16.017 7.16296 16.0902 7.33957C16.1633 7.51618 16.2706 7.67665 16.4057 7.81182L22.6445 14.0469H4.8437C4.45831 14.0469 4.0887 14.2 3.81619 14.4725C3.54368 14.7451 3.39058 15.1147 3.39058 15.5001Z",
    fill: "url(#paint0_linear_1_316)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_316",
    x1: 15.4121,
    y1: 6.8038,
    x2: 15.7168,
    y2: 43.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#886032"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowR);
export default __webpack_public_path__ + "static/media/arrowR.25b92c1685eeae7b73d8a4761ec9d8b0.svg";
export { ForwardRef as ReactComponent };